export default '1.0.0';



// WEBPACK FOOTER //
// ./version.js